module.exports = __webpack_public_path__ + "f572638f/img/defaultProductImg.220a180f.svg";